module.exports = __webpack_public_path__ + "static/media/knights-silhouette.e3053ea8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/knights-silhouette.svg
// module id = 1329
// module chunks = 0